module.exports = __webpack_public_path__ + "img/pablo_micas.7899b759.jpg";